import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-service-four',
  templateUrl: './service-four.component.html',
  styleUrls: ['./service-four.component.css']
})
export class ServiceFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
